module.exports = __webpack_public_path__ + "img/svg/background-error-mobile.3c7162c29439d569674031f4f448a352.svg";